import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Addon } from '@galaxy/marketplace-apps/v1';
import { Product } from '../shared/product';

@Component({
  selector: 'store-products-nav',
  templateUrl: './products-nav.component.html',
  styleUrls: ['./products-nav.component.scss'],
  standalone: false,
})
export class VaProductsNavComponent {
  @Input() items: (Addon | Product)[];
  @Input() hideItemsNav: boolean;
  @Output() itemSelected = new EventEmitter();

  selectedIndex = 0;
  pageMarker = 0;

  onItemSelected(index: any): void {
    this.selectedIndex = index;
    this.itemSelected.emit(index);
  }

  moveSlides<T extends HTMLElement>(slides: T): void {
    const sliderWidth = Math.round(slides.offsetWidth / slides.children[0].clientWidth);
    const numSlides = Math.ceil(slides.children.length / sliderWidth);
    if (numSlides === 0) {
      return;
    }
    const pageWidth = slides.offsetWidth;
    let move = 0;

    if (this.pageMarker === -1) {
      this.pageMarker = numSlides - 1; // go to end
      move = pageWidth * this.pageMarker;
      slides.style.left = `-${move}px`;
    } else if (this.pageMarker >= numSlides) {
      slides.style.left = '0px';
      this.pageMarker = 0; // reset
    } else {
      move = pageWidth * this.pageMarker;
      slides.style.left = `-${move}px`;
    }
  }

  pageNext<T extends HTMLElement>(slides: T): void {
    this.pageMarker++;
    this.moveSlides(slides);
  }

  pagePrev<T extends HTMLElement>(slides: T): void {
    this.pageMarker--;
    this.moveSlides(slides);
  }
}
